import React, { useEffect,useState } from 'react'
import './style.css'
import { useNavigate,useParams } from "react-router-dom";
import branchIcon from '../../../assets/icons/branch-svgrepo.svg';
import BranchDetailsInfoContainer from '../../../components/DashboardComponents/BranchDetailsInfoContainer/BranchDetailsInfoContainer';
import ProfileIntiationLablesContainer from '../../../components/DashboardComponents/ProfileIntiationLablesContainer';
import GetRequest from '../../../service/GetRequest';
import CookieHandler from '../../LandingPage/Authentication/CookieHandler'

const BranchesListPage = ({setActivePath , header, description, headerActionName, headerActionNavigationLink, isSaveAndContinueRequired, saveButtonNavigationLink}) => {
  const navigate = useNavigate();
  const userId = CookieHandler.getCookie("userid");
  const [BranchList,setBranchList ] = useState([]);
  const [storeName, setStoreName] =useState("");
  const { storeId } = useParams(); // Assuming 'data' is the parameter name

  
  useEffect(() => {
    setActivePath(" Branches");


    GetRequest("v1/store-management-service/view/my/store",true)
            .then(response => {
                if (!response || response === undefined) {
                    console.log("No store found for this user");
                } else {
                    console.log(response);
                    setStoreName(response.brandName)
                    setBranchList(response.storeBranches);
                }
            })
            .catch(error => {
                console.error("Error fetching store data:", error);
            });
            
  }, [setActivePath,userId]);


  return (
    <div className="outlet-container">
      <div className="background-white">
        <div className="background-white-sub-container">                  <br/>


        <ProfileIntiationLablesContainer title={header} description={description} status={true} navigation={headerActionNavigationLink+"/"+storeId} icon={branchIcon} iconBackgroundColor="#59BFF1" actionName={headerActionName} isActionRequired/>

     <br/>
     

      {BranchList.length === 0 ? (
            <div>
              <div className="flex justify-center items-center h-screen">
                <div className="text-center">
                  <div className="mb-5">No branches found</div>
                </div>
              </div>
            </div>
          ) : (
            <div className="branch-details-container-padding">
              {BranchList.map((item, index) => (
                <BranchDetailsInfoContainer
                  key={index} // Ensure each component has a unique key
                  paddingRequired // Assuming you always want padding
                  actionRequired // Assuming action is always required
                  actionName="View"
                  storeName={storeName}
                />
              ))}
            </div>
          )}
     
           {isSaveAndContinueRequired && (
          <div onClick={() => navigate(saveButtonNavigationLink)} className="flex justify-center items-center cursor-pointer px-16 py-4 mt-10 mr-9 max-w-full text-lg font-medium text-white bg-sky-500 rounded-lg w-[379px] max-md:px-5 hover:bg-black hover:text-white transition duration-300 ease-in-out">
          Save and Continue
        </div>
        )}
          </div>
        </div>
        </div>



  )
}

export default BranchesListPage
